import React, { useState, useEffect } from 'react';
import { SearchFilters } from '../../routes/AvailabilityGuard';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { DropdownOption } from './molecules/Dropdown';
import ArrowDown2 from 'iconsax-react/dist/esm/ArrowDown2';
import { FILTER_CHANGED, analytics } from '../../helpers/analytics';
import { useFilterAnalytics } from '../../helpers/analytics/filterContext';
import { useTranslation } from 'react-i18next';


type PartySizeDropdownProps = {
	searchFilters: SearchFilters;
	onChange?: (newOption: PartySizeOption) => void;
	defaultValue?: number;
	options: PartySizeOption[];
	analyticsOption?: any;
};

export interface PartySizeOption extends DropdownOption {
	inboundRequest: boolean;
}

export const PartySizePicker = ({
	searchFilters,
	options = [],
	onChange,
	analyticsOption = {}
}: PartySizeDropdownProps) => {
	const { t } = useTranslation();
	const filterCtx = useFilterAnalytics('global page');

	const [selectedGroupSize, setSelectedGroupSize] = useState<PartySizeOption>();
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const handleGroupSizeChange = (option) => {
		const partySizeOption = option as PartySizeOption;
		setSelectedGroupSize(option);
		onChange?.(option);
		analytics.track(FILTER_CHANGED, {
			filterName: 'groupSize',
			filterValue: partySizeOption.value,
			...analyticsOption,
			...filterCtx
		});
	};

	useEffect(() => {
		if (searchFilters?.groupSize) {
			setSelectedGroupSize(options.find((option) => Number(option.value) === searchFilters.groupSize));
		}
		else {
			setSelectedGroupSize(undefined);
		}
	}, [searchFilters.groupSize, options]);


	return (
		<div className="w-full">
			<DropdownMenu onOpenChange={setIsOpen}>
				<DropdownMenuTrigger className={'w-full rounded-2xl bg-tablz-med-gray-2 hover:bg-tablz-med-gray-4 flex justify-between border border-tablz-med-gray-4 py-1 px-3 items-center'}>
					<div className="p-1 flex flex-col justify-center items-baseline">
						<p className="font-poppins text-tablz-text-gray-1 text-sm leading-5">{t('titles.party_size')}</p>
						<p className="font-poppins text-tablz-text-white-1 text-lg font-medium leading-5">
							{selectedGroupSize?.label ? selectedGroupSize?.label : t('placeholders.select_party_size', { defaultValue: 'Select Party Size' })}
						</p>

					</div>
					<ArrowDown2 className={`${isOpen && 'rotate-180'}`} />
				</DropdownMenuTrigger>
				<DropdownMenuContent className="w-[var(--radix-dropdown-menu-trigger-width)] rounded-2xl border border-tablz-med-gray-4 p-1 gap-1 bg-tablz-med-gray-2">
					{options.map((option, index) =>
						<DropdownMenuItem onClick={() => handleGroupSizeChange(option)} className='p-4 w-full bg-tablz-med-gray-2 cursor-pointer rounded-2xl hover:bg-tablz-med-gray-4' key={index}>
							<p className="font-poppins font-semibold text-base">{option.label}</p>
						</DropdownMenuItem>
					)}
				</DropdownMenuContent>
			</DropdownMenu>
		</div>
	);
};
